import { NOTIFICATIONTYPE_INVITED_TO_HEARING } from '../../../../constants/api';
import { getEntityId } from '../../../../features/helpers/apiHelpers';
import { UpdateNotificationContentPanel } from '../UpdateNotificationContentPanel';
import { InvitationButtons } from './createHearingInvitations/InvitationButtons';
import { InvitationCommandBar } from './createHearingInvitations/InvitationCommandBar';
import { InviteeMetaDataInfoBox } from './createHearingInvitations/InviteeMetaDataInfoBox';
import { InviteesList } from './createHearingInvitations/InviteesList';
import { UpdateInvitationGroupInviteePanel } from './createHearingInvitations/UpdateInvitationGroupInviteePanel';
import { UpdatePersonalInviteePanel } from './createHearingInvitations/UpdatePersonalInviteePanel';
import { UploadFileInviteePanel } from './createHearingInvitations/UploadFileInviteePanel';
import { useData } from './createHearingInvitations/utility/useData';
import { useFilterAndSort } from './createHearingInvitations/utility/useFilterAndSort';
import { useInteractions } from './createHearingInvitations/utility/useInteractions';
import { InviteeChangedPanel } from './InviteeChangedPanel';

const CreateHearingInvitations = ({ hearingModel }) => {
  const hearingId = getEntityId(hearingModel);

  const {
    hearingStatus,
    isUpdatingHearing,
    invitationSources,
    invitationSourceMappings,
    invitedUsers,
    invitedCompanies,
    invitedUserHearingRoles,
    invitedCompanyHearingRoles,
    invitationGroupsForHearingType,
    invitationNotifications,
    invitationNotificationQueues,
  } = useData(hearingId);

  const {
    titleFilter,
    filteredAndSortedItems,
    groups,
    handleTitleFilterChange,
  } = useFilterAndSort(
    invitationSourceMappings,
    invitationSources,
    invitedUsers,
    invitedCompanies,
    invitedUserHearingRoles,
    invitedCompanyHearingRoles,
    invitationNotifications,
    invitationNotificationQueues,
  );

  const {
    selectedInvitationSource,
    handleInvitationSourceClick,
    handleEditInvitationNotificationClick,
  } = useInteractions();

  return (
    <div className="create-hearing-invitations">
      <div className="invitation-container">
        <InvitationCommandBar
          invitationSources={invitationSources}
          titleFilter={titleFilter}
          handleTitleFilterChange={handleTitleFilterChange}
          handleInvitationSourceClick={handleInvitationSourceClick}
          handleEditInvitationClick={handleEditInvitationNotificationClick}
        />
        <InviteesList
          hearingId={hearingId}
          groups={groups}
          items={filteredAndSortedItems}
        />
        <InvitationButtons
          hearingStatus={hearingStatus}
          isUpdatingHearing={isUpdatingHearing}
        />
        <UploadFileInviteePanel
          hearingId={hearingId}
          selectedInvitationSource={selectedInvitationSource}
        />
        <UpdateInvitationGroupInviteePanel
          hearingId={hearingId}
          selectedInvitationSource={selectedInvitationSource}
          invitationGroups={invitationGroupsForHearingType}
        />
        <UpdatePersonalInviteePanel
          hearingId={hearingId}
          selectedInvitationSource={selectedInvitationSource}
        />
        <InviteeChangedPanel />
        <UpdateNotificationContentPanel
          hearingId={hearingId}
          notificationTypeValue={NOTIFICATIONTYPE_INVITED_TO_HEARING}
        />
      </div>
      <div>
        <InviteeMetaDataInfoBox
          invitedUsers={invitedUsers}
          invitedCompanies={invitedCompanies}
          invitationNotificationQueues={invitationNotificationQueues}
        />
      </div>
    </div>
  );
};

export { CreateHearingInvitations };
